// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var sticky = "Footer-module--sticky--jlumA";
export var waiver = "Footer-module--waiver--lkHnQ";
export var bottomMenu = "Footer-module--bottomMenu--wzS9r";
export var copy = "Footer-module--copy--uYMUB";
export var address = "Footer-module--address--55y05";
export var icons = "Footer-module--icons--M1MId";